module.exports = __webpack_public_path__ + "static/img/google.df820c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/google.jpg
// module id = kQrs
// module chunks = 1